import { Link } from "react-router-dom";
import type { SectionProps } from "../types";
import { courses } from "../data";

export default function CoursesSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="courses"
      className="py-16 sm:py-20 bg-gray-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 sm:mb-12 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-3 sm:mb-4 px-4">
            Chương Trình Đào Tạo
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            Các khóa học được thiết kế theo chuẩn doanh nghiệp, cập nhật công nghệ
            mới nhất
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6 max-w-6xl mx-auto">
          {courses.map((course, index) => (
            <div
              key={course.id}
              className={`group bg-white rounded-xl p-4 sm:p-5 md:p-6 border border-gray-200 hover:border-cyan-500 transition-all duration-500 hover:shadow-xl cursor-pointer ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4">
                <div
                  className={`w-12 h-12 sm:w-14 sm:h-14 flex-shrink-0 flex items-center justify-center bg-gradient-to-br ${course.color} rounded-xl group-hover:scale-110 transition-all duration-300 shadow-md`}
                >
                  <i className={`${course.icon} text-xl sm:text-2xl text-white`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#2a4b7c] mb-1.5 sm:mb-2 group-hover:text-cyan-600 transition-colors">
                    {course.title}
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    {course.description}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-4">
                {course.topics.map((topic, idx) => (
                  <span
                    key={idx}
                    className="px-2 sm:px-2.5 py-0.5 sm:py-1 bg-gray-50 text-gray-600 text-[10px] sm:text-xs font-medium rounded-md border border-gray-200 hover:bg-[#2a4b7c] hover:text-white hover:border-[#2a4b7c] transition-all duration-200 cursor-pointer"
                  >
                    {topic}
                  </span>
                ))}
              </div>
              <Link
                to="/lien-he"
                className="inline-flex items-center gap-2 text-cyan-600 font-semibold text-xs sm:text-sm hover:gap-3 transition-all duration-300"
              >
                Xem chi tiết
                <i className="ri-arrow-right-line text-xs sm:text-sm"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

